import type { IndicatorsDisplay } from '../../../core/components/annotations/components/indicators/types.js';
import type {
  BaseMarkerProps,
  TimeMarkerProps,
} from '../../../core/components/annotations/types/annotations-marker-props.js';

/**
 * TimeseriesChart Annotations.Marker subcomponent props
 * @public
 */
export interface TimeseriesAnnotationsMarkerProps
  extends BaseMarkerProps,
    TimeMarkerProps {
  /**
   * Defines how to show the marker indicator on top of the chart: always, never, or on hover (auto)
   * @defaultValue 'auto'
   */
  indicatorsDisplay?: IndicatorsDisplay;
}

/**
 * @public
 */
export const Marker = (props: TimeseriesAnnotationsMarkerProps) => null;

Marker['displayName'] = 'TimeseriesAnnotations.Marker';
